import React from 'react';
import OtcDateRange from 'ui-components/react/OtcDateRange';

export default function DateFieldRange(prop) {
  return <OtcDateRange {...prop} />
}


// WEBPACK FOOTER //
// ./src/components/common/DateFieldRange/DateFieldRange.jsx